/* Refine only the existing outer launcher. Google's iframe still owns its card. */
(() => {
  const root = document.documentElement;
  const key = 'ck-google-introduction-v2';
  const sequenceKey = 'ck-mobile-widget-sequence-v1';
  const mq = matchMedia('(max-width: 600px)');
  const scoped = root.hasAttribute('data-ck-widget-sequence');
  let wrapper, frame, caption, observer, elapsed = 0, last = 0, timer;
  let seen = false, nativeIntroSeen = false, chatElapsed = 0, gapElapsed = 0, sequenceTimer;
  let nativeIntroVisibleAt = null;
  let stage = scoped ? root.getAttribute('data-ck-widget-sequence') : '';
  try { seen = sessionStorage.getItem(key) === '1'; } catch (_) {}
  if (scoped && mq.matches) seen = stage === 'done';
  function setStage(value) {
    if (stage === value) return;
    stage = value;
    root.setAttribute('data-ck-widget-sequence', value);
    performance.mark('ck-widget-' + value);
    window.dispatchEvent(new Event('ck:widget-sequence'));
  }
  function obstructed() {
    return document.hidden || root.matches('.ck-human-chat-open, .js-drawer-open, .ck-google-details-open') || document.body.classList.contains('ck-ecomsend-modal-open') || !!document.querySelector('.ck-luna__drawer[aria-hidden="false"]');
  }
  function complete() {
    setStage('done');
    clearInterval(sequenceTimer);
    try { sessionStorage.setItem(sequenceKey, 'done'); } catch (_) {}
  }
  function finish() {
    seen = true;
    if (caption) caption.hidden = true;
    clearInterval(timer);
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
    if (scoped && stage === 'google') { setStage('gap'); gapElapsed = 0; }
  }
  function update() {
    const width = parseFloat(wrapper.style.width) || 0;
    const height = parseFloat(wrapper.style.height) || 0;
    const state = width > 100 ? (height > 130 ? 'open' : 'intro') : 'icon';
    const previousState = wrapper.dataset.ckGoogleState;
    const previousCaption = {hidden: caption.hidden, left: caption.style.left, bottom: caption.style.bottom};
    wrapper.dataset.ckGoogleState = state;
    if (state === 'icon' && width > 0) wrapper.dataset.ckGoogleEnhanced = 'true';

    const blocked = document.hidden || wrapper.hidden || (getComputedStyle(frame).visibility === 'hidden' && !(document.body.classList.contains('ck-pdp-widget-buying-clear') && !obstructed())) || (scoped && mq.matches && obstructed());
    // A brief loading flash or hidden introduction has not been seen by a customer.
    if (scoped && mq.matches && (state === 'intro' || state === 'open') && !blocked && getComputedStyle(frame).visibility !== 'hidden') {
      if (nativeIntroVisibleAt === null) nativeIntroVisibleAt = performance.now();
      if (performance.now() - nativeIntroVisibleAt >= 500) nativeIntroSeen = true;
    } else nativeIntroVisibleAt = null;
    caption.hidden = seen || blocked || state !== 'icon' || width === 0;
    if (scoped && mq.matches) {
      caption.hidden = caption.hidden || stage !== 'google' || nativeIntroSeen;
      // Wait for Google's actual collapse, never start Chat on an assumed timeout.
      if (stage === 'google' && state === 'icon' && width > 0 && nativeIntroSeen && !blocked) finish();
      // A customer's open card keeps Chat compact until they close it themselves.
      if (state !== 'icon' && stage === 'chat') { setStage('gap'); gapElapsed = 0; }
    } else if (state === 'open') finish();
    if (!caption.hidden) {
      const rect = wrapper.getBoundingClientRect();
      caption.style.left = Math.max(12, rect.left + 16) + 'px';
      caption.style.bottom = Math.max(76, innerHeight - rect.top + 4) + 'px';
    }
    if (previousState !== state || (document.body.classList.contains('template-product') &&
      (previousCaption.hidden !== caption.hidden || previousCaption.left !== caption.style.left || previousCaption.bottom !== caption.style.bottom))) {
      window.dispatchEvent(new Event('ck:widget-sequence'));
    }
  }
  function attach() {
    wrapper = document.getElementById('google-merchantwidget-iframe-wrapper');
    frame = document.getElementById('merchantwidgetiframe');
    if (!wrapper || !frame) return false;
    caption = document.createElement('div'); caption.className = 'ck-google-introduction'; caption.hidden = true; caption.setAttribute('aria-hidden', 'true');
    const title = document.createElement('strong'); title.textContent = 'Top Quality Store';
    const sub = document.createElement('span'); sub.textContent = 'on Google';
    caption.append(title, sub); document.body.appendChild(caption);
    wrapper.dataset.ckGoogleEnhanced = 'true';
    observer = new MutationObserver(update);
    observer.observe(wrapper, {attributes: true, attributeFilter: ['style', 'hidden']});
    observer.observe(root, {attributes: true, attributeFilter: ['class']});
    observer.observe(document.body, {attributes: true, attributeFilter: ['class']});
    setTimeout(() => { if (wrapper.dataset.ckGoogleState === 'intro') delete wrapper.dataset.ckGoogleEnhanced; }, 6000);
    update(); last = performance.now();
    timer = setInterval(() => {
      update(); const now = performance.now();
      if (!caption.hidden && getComputedStyle(caption).visibility !== 'hidden' && getComputedStyle(frame).visibility !== 'hidden' && caption.getBoundingClientRect().width > 0 && caption.getBoundingClientRect().height > 0 && frame.getBoundingClientRect().width > 0 && frame.getBoundingClientRect().height > 0) elapsed += now - last;
      last = now;
      if (elapsed >= (scoped && mq.matches ? 3000 : 8000) || seen) finish();
    }, 100);
    addEventListener('resize', update, {passive: true});

    return true;
  }
  function startSequenceTimer() {
    if (!scoped || !mq.matches || stage === 'done' || sequenceTimer) return;
    // Desktop arrival must not consume the later mobile introduction.
    try { sessionStorage.setItem(sequenceKey, 'started'); } catch (_) { complete(); return; }
    let tickLast = performance.now();
    sequenceTimer = setInterval(() => {
      const now = performance.now(), delta = Math.min(now - tickLast, 300); tickLast = now;
      if (!mq.matches || stage === 'done') { clearInterval(sequenceTimer); sequenceTimer = null; return; }
      if (obstructed()) return;
      const state = wrapper?.dataset.ckGoogleState;
      if ((stage === 'gap' || stage === 'chat') && wrapper && (state !== 'icon' || wrapper.hidden || getComputedStyle(frame).visibility === 'hidden')) return;
      if (stage === 'gap' && document.querySelector('.ck-luna__bubble[data-luna-open]')) {
        gapElapsed += delta;
        if (gapElapsed >= 400) setStage('chat');
      } else if (stage === 'chat') {
        chatElapsed += delta;
        if (chatElapsed >= 3000) complete();
      }
    }, 100);
  }
  if (scoped) {
    startSequenceTimer();
    mq.addEventListener('change', startSequenceTimer);
    // Direct customer interaction cancels automatic introductions, never closes their chat.
    document.addEventListener('click', event => {
      if (mq.matches && event.target.closest?.('.ck-luna__bubble[data-luna-open], [data-ck-google-details]')) { finish(); complete(); }
    }, true);
  }
  // Handle departure even before the vendor widget has loaded.
  addEventListener('pagehide', () => {
    if (wrapper) finish();
    if (scoped && mq.matches) complete();
  }, {once: true});
  if (!attach()) {
    const discovery = new MutationObserver(() => { if (attach()) discovery.disconnect(); });
    discovery.observe(document.body, {childList: true});
    setTimeout(() => { discovery.disconnect(); if (scoped && !wrapper) finish(); }, 15000);
  }
})();


/* Google owns its separate live card; inline recognition opens an on-site explanation. */
(() => {
  const triggers = [...document.querySelectorAll('[data-ck-google-details]')];
  if (!triggers.length) return;
  const root = document.documentElement;
  const card = document.createElement('section');
  card.id = 'ck-google-details';
  card.className = 'ck-google-details';
  card.hidden = true;
  card.setAttribute('role', 'dialog');
  card.setAttribute('aria-labelledby', 'ck-google-details-title');
  card.innerHTML = '<button class="ck-google-details__close" type="button" aria-label="Close store recognition details">×</button><div class="ck-google-details__heading"><h2 id="ck-google-details-title">Top Quality Store<span>on Google</span></h2></div><p>Google recognizes Capital Kidz for a great shopping experience.</p><a class="ck-google-details__link" href="https://www.google.com/storepages?c=US&amp;hl=en&amp;q=capitalkidz.com" target="_blank" rel="noopener">View store on Google <span aria-hidden="true">↗</span></a>';
  const icon = triggers[0].querySelector('svg');
  if (icon) card.querySelector('.ck-google-details__heading').prepend(icon.cloneNode(true));
  document.body.appendChild(card);
  const closeButton = card.querySelector('button');
  let activator;
  function close(restoreFocus = true) {
    if (card.hidden) return;
    card.hidden = true;
    root.classList.remove('ck-google-details-open');
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    if (restoreFocus && activator?.isConnected) activator.focus({preventScroll: true});
  }
  triggers.forEach(trigger => {
    trigger.setAttribute('aria-controls', card.id);
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (!card.hidden && activator === trigger) { close(); return; }
      activator = trigger;
      triggers.forEach(item => item.setAttribute('aria-expanded', String(item === trigger)));
      card.hidden = false;
      root.classList.add('ck-google-details-open');
      closeButton.focus({preventScroll: true});
    });
  });
  closeButton.addEventListener('click', () => close());
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !card.hidden) { event.preventDefault(); close(); }
  });
  document.addEventListener('pointerdown', event => {
    if (!card.hidden && !card.contains(event.target) && !triggers.some(item => item.contains(event.target))) close(false);
  });
  function respectStoreControls() {
    if (card.hidden) return;
    if (root.matches('.ck-human-chat-open, .js-drawer-open') || document.body.classList.contains('ck-ecomsend-modal-open') || document.querySelector('.ck-luna__drawer[aria-hidden="false"]')) close(false);
  }
  const controls = new MutationObserver(respectStoreControls);
  controls.observe(root, {attributes: true, attributeFilter: ['class']});
  controls.observe(document.body, {attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden']});
})();
